import React from "react";
import CyberPostureTab from "@/components/CyberPostureTab";
import { usePortalAuth } from "./portalAuth";

export default function PortalCyberPosture() {
  const { user } = usePortalAuth();
  return (
    <div className="space-y-6" data-testid="portal-cyber-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-blue-700">Security</div>
        <h1 className="font-heading text-3xl font-bold text-slate-900 mt-1">Cyber Posture</h1>
        <p className="text-slate-500 text-sm mt-1">
          Latest Current State Assessment of {user.account.name}, scored using the NIST framework.
        </p>
      </div>
      <CyberPostureTab accountId={user.account.id} isCustomer />
    </div>
  );
}
